import * as React from 'react';
import { WithCommonProps } from '@types';
import { getFieldTextareaStylesAsClassName } from './field-textarea-styles';
import { twMerge } from 'tailwind-merge';

export interface IFieldTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Flag to indicate whether the input has an invalid value */
  isInvalid?: boolean;
  /** Indicate if the label should be visible */
  showLabel?: boolean;
  /** Tab index html attribute */
  tabIndex?: number;
}

export type FieldTextareaProps = WithCommonProps<IFieldTextareaProps>;

export const FieldTextarea = React.forwardRef(
  (
    props: FieldTextareaProps,
    ref: React.ForwardedRef<HTMLTextAreaElement>
  ): JSX.Element => {
    const {
      name,
      isInvalid = false,
      showLabel = true,
      disabled = false,
      readOnly = false,
      className: classNameProp,
      ...rest
    } = props;
    const twClassName = twMerge(
      getFieldTextareaStylesAsClassName(
        isInvalid,
        showLabel,
        disabled,
        readOnly
      ),
      classNameProp
    );
    return (
      <textarea
        name={name}
        id={name}
        ref={ref}
        className={twClassName}
        {...rest}
      />
    );
  }
);

FieldTextarea.displayName = 'FieldTextarea';
